/**
 * 是否为对象
 * @param o 入参
 */
export function isObject(o) {
  return Object.prototype.toString.call(o).slice(8, -1) === "Object";
}

/**
 * 是否为数字
 * @param o 入参
 */
export function isNumber(o) {
  return Object.prototype.toString.call(o).slice(8, -1) === "Number";
}

/**
 * 遍历目标对象的每个key分别，从源对象获取数据并赋值，仅支持{}对象。
 * @param target 目标对象
 * @param source 源对象
 */
export function allGive(target, source) {
  if (!isObject(target) || !isObject(source)) return;
  Object.keys(target).forEach(function (key) {
    if (source[key] !== undefined) {
      target[key] = source[key];
    }
  });
}

/** 下载文件，自定义文件名称 */
export function downFile(url, fileName) {
  const x = new XMLHttpRequest();
  x.open("GET", url, true);
  x.responseType = "blob";
  x.onload = function () {
    const url = window.URL.createObjectURL(x.response);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    a.click();
  };
  x.send();
}

/**
 * 千分位 过滤器 用于金额 (不管整数还是小数 按照fillZero要求补零)
 * @param value key
 * @param precision 保留几位小数
 * @param fillZero 实际小数位小于precision时 是否补零
 * @param separator 分隔符
 */
export function thousands(value, precision, fillZero, separator) {
  if (precision === void 0) {
    precision = 2;
  }
  if (fillZero === void 0) {
    fillZero = true;
  }
  if (separator === void 0) {
    separator = ",";
  }
  var num = Number(value);
  // 判断是否为数字
  if (isNumber(num) && !Number.isNaN(num)) {
    var numStr = "";
    if (isNumber(precision)) {
      if (fillZero) {
        numStr = num.toFixedNew(precision).toString();
      } else {
        var decimals = String(num).split(".")[1];
        decimals = decimals ? decimals.length : 0;
        if (decimals > precision) {
          decimals = precision;
        }
        numStr = num.toFixedNew(decimals).toString();
      }
    } else {
      numStr = num.toString();
    }
    var parts = numStr.split(".");
    parts[0] = parts[0].toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + (separator || ","));
    return parts.join(".");
  }
  return value;
}

/**
 * 数字 过滤器 用于非金额的数字 (如果是整数不补零 如果是小数按照precision要求补零)
 * @param value key
 * @param precision 保留几位小数
 * @param separator 分隔符
 */
export function thousandsNumber(value, precision, separator) {
  console.log("thousandsNumber", value);
  if (precision === void 0) {
    precision = 2;
  }
  if (separator === void 0) {
    separator = ",";
  }
  var num = Number(value);
  // 判断是否为数字
  if (isNumber(num) && !Number.isNaN(num)) {
    var numStr = "";
    if (isNumber(precision)) {
      if (!Number.isInteger(num)) {
        numStr = num.toFixedNew(precision).toString();
      } else {
        var decimals = String(num).split(".")[1];
        decimals = decimals ? decimals.length : 0;
        if (decimals > precision) {
          decimals = precision;
        }
        numStr = num.toFixedNew(decimals).toString();
      }
    } else {
      numStr = num.toString();
    }
    var parts = numStr.split(".");
    parts[0] = parts[0].toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + (separator || ","));
    return parts.join(".");
  }
  return value;
}
